export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_15.503db67a.jpg";